import { useStore } from 'effector-react';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import {
  $selectedRecipeStore,
  setSelectedRecipeStore,
} from '../../store/recipes.store';
import {
  $selectedBunkerType,
  setSelectedBunkerType,
} from '../../store/selected-bunkers.store';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import { IRecipesWarehouse } from '../../ts';
import { RecipesSidebar } from '../../components/recipes-sidebar';
import { PageTemplate } from '@/shared/ui/templates';
import { RecipeDetail } from '../../components/recipes-detail';
import {
  $availableBunkers,
  $warehousesForMixingData,
  fetchAvailableBunkers,
  fetchTopRecipesForWarehouse,
  fetchWarehousesForMixingDataFx,
} from '@/widgets/recipe/model';
import { SelectBunkerModal } from '../../components/recipe-select-bunker';
import styles from './index.module.sass';

export const RecipesPageNew = () => {
  const location = useLocation();
  const [_searchParams, setSearchParams] = useSearchParams();
  const searchParams = new URLSearchParams(location.search);
  const tons = searchParams.get('tons');
  const recipesCount = searchParams.get('recipes_count');
  const mixAlgo = searchParams.get('mix_algo');
  const wrapRef: any = useRef(null);

  const activeWh = useStore($selectedRecipeStore);
  const warehousesList: IRecipesWarehouse[] = useStore($warehousesForMixingData);
  const bunkerData = useStore($availableBunkers);
  const bunkerType = useStore($selectedBunkerType);

  const preSelectedTab = _searchParams.get('active_tab')
    ? Number(_searchParams.get('active_tab'))
    : localStorage.getItem('recipes_active_tab');
  const preSelectedWh = _searchParams.get('warehouse_id');

  const [selectedRecipe, setSelectedRecipe] = useState(-1);
  const [displayModal, setDisplaySelect] = useState(false);
  const [mixingModal, setMixingModal] = useState(false);
  const [activeTab, setActiveTab] = useState(Number(preSelectedTab) || 0);

  const [isSidebarVisible, setIsSidebarVisible] = useState(true); // используется для версии страницы под экраны, меньше 1280px
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    localStorage.setItem('recipes_active_tab', String(activeTab));
    //setSearchParams({ active_tab: String(activeTab) });
  }, [activeTab]);

  const selectRecipe = (id: number) => {
    setSelectedRecipe(id);
    setMixingModal(true);
  };

  useEffect(() => {
    fetchWarehousesForMixingDataFx({
      tons: Number(tons),
      recipesCount: Number(recipesCount),
      mixAlgo: Number(mixAlgo),
    });
    fetchAvailableBunkers();
    activeWh?.id && fetchTopRecipesForWarehouse(Number(activeWh?.id));
  }, []);

  useEffect(() => {
    const whId = Number(preSelectedWh);
    if (whId && typeof whId === 'number') {
      const wh = warehousesList.find(item => item.id === whId);
      wh && setSelectedRecipeStore(wh);
    }
  }, [preSelectedWh, warehousesList]);

  return (
    <PageTemplate
      className={styles.pageRoot}
      header={isSidebarVisible ? 'аналитическое миксование' : activeWh?.title}
      customBack={isSidebarVisible ? '/mixing' : undefined}
      customAction={
        isSidebarVisible
          ? undefined
          : { label: 'назад', action: () => setIsSidebarVisible(true) }
      }
    >
      <div className={styles.root} ref={wrapRef}>
        <RecipesSidebar
          isSidebarVisible={!!(isSidebarVisible && width <= 1280)}
          setIsSidebarVisible={setIsSidebarVisible}
          data={warehousesList}
          activeRecipe={activeWh}
          setPresetTab={setActiveTab}
        />
        <RecipeDetail
          isSidebarVisible={!!(isSidebarVisible && width <= 1280)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selectRecipeFoo={selectRecipe}
          setDisplaySelect={setDisplaySelect}
          mixingModal={mixingModal}
          setMixingModal={setMixingModal}
          selectedRecipe={selectedRecipe}
        />
      </div>

      {displayModal && (
        <SelectBunkerModal
          warehouseId={String(activeWh?.id)}
          recipeId={selectedRecipe}
          onClose={() => setDisplaySelect(false)}
          options={bunkerData?.map((item: any) => ({
            value: item.id,
            label: item.model_name,
            tonnage: item.lifting_capacity,
            type: item.type,
          }))}
          type={bunkerType}
          setType={setSelectedBunkerType}
          selectedRecipe={selectedRecipe}
        />
      )}
    </PageTemplate>
  );
};
